module.exports = __webpack_public_path__ + "static/banner-sp-c4ea2bace9f5b015bdbc0728ad5a7654.png";